import dayjs from "dayjs";
import type { ContractDetailsResponse } from "~/features/contracts/models/models";
import {
  ContractLineItemStatus,
  CONTRACT_LINE_ITEM_STATUS_CODES,
} from "~/features/contracts/models/contractLineItemStatus";
import { isDateInvalidForDelivery } from "~/common/utils/dateUtils";

export const getContractYears = (contractDetails: ContractDetailsResponse) => {
  let maxYear = undefined;
  let minYear = undefined;
  const status = CONTRACT_LINE_ITEM_STATUS_CODES[contractDetails.status as keyof typeof CONTRACT_LINE_ITEM_STATUS_CODES];

  if (status === ContractLineItemStatus.Active) {
    if (contractDetails.contractValidTo) {
      maxYear = dayjs(contractDetails.contractValidTo).get("year");
    }
    if (contractDetails.contractValidFrom) {
      minYear = dayjs(contractDetails.contractValidFrom).get("year");
      minYear = Math.max(minYear, dayjs().toDate().getFullYear());
    }
  }
  return { minYear, maxYear };
};

export function contractIsDayDisabled(contractDetails: ContractDetailsResponse, date: Date) {
  if (isDateInvalidForDelivery(date)) {
    return true;
  }

  const { minYear, maxYear } = getContractYears(contractDetails);
  const value = dayjs(date);

  let isDisabled = false;
  if (minYear) {
    isDisabled = isDisabled || value.isBefore(contractDetails.contractValidFrom, "y");
  }
  if (maxYear && minYear !== maxYear) {
    isDisabled = isDisabled || value.isAfter(contractDetails.contractValidTo, "y");
  }

  return isDisabled;
}
